if (!customElements.get('step-guides')) {
  class StepGuides extends HTMLElement {
    constructor() {
      super();

      this.initTabs();
      this.initExpand();
    }

    initTabs() {
      if (!this.hasAttribute('data-tabs')) {
        return;
      }

      const tabs = this.querySelectorAll('[data-tab-target]');
      const panels = this.querySelectorAll('[data-tab-panel]');

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const target = tab.getAttribute('data-tab-target');

          tabs.forEach(item => {
            item.classList.remove('is-active');
            item.setAttribute('aria-selected', 'false');
          });

          panels.forEach(panel => {
            panel.classList.remove('is-active');
          });

          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');

          const activePanel = this.querySelector(
            `[data-tab-panel="${target}"]`
          );

          if (activePanel) {
            activePanel.classList.add('is-active');
          }
        });
      });
    }

    initExpand() {
      if (!this.hasAttribute('data-expandable')) {
        return;
      }

      this.querySelectorAll('[data-expand]').forEach(button => {
        const card = button.closest('.step-guides__card');
        const body = card ? card.querySelector('[data-expand-body]') : null;
        const label = button.querySelector('[data-expand-label]');

        if (!body) {
          return;
        }

        button.addEventListener('click', () => {
          const isOpen = button.getAttribute('aria-expanded') === 'true';

          button.setAttribute('aria-expanded', String(!isOpen));
          body.classList.toggle('is-open', !isOpen);

          if (label) {
            label.textContent = isOpen ? 'View more' : 'View less';
          }
        });
      });
    }
  }

  customElements.define('step-guides', StepGuides);
}
